export const navigationHotKeys = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  'e',
  'y',
  'u',
  'o',
  'h',
  'j',
  'k',
  'l',
  'z',
  'b',
  'm',
  'g',
  '/',
  ';',
  "'",
  '[',
  ']',
];

export const hotKeys = {
  openFilters: '.',
  accountReceivable: 'p',
  createNew: 'i',
  goBack: '←',
  download: 'd',
};
